// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header_header_container__fs\\+2C{ 
    display: flex;
    flex:  5 1;
    flex-direction: row;
    align-items: flex-start;
    align-content: flex-start;
    justify-content: center;
    background-color: var(--hsrcBackgroundLight);
    border-radius: 1rem;
    justify-content: space-around;
    

 }

 .header_banner__lF6g8{
  display: flex;
  vertical-align: bottom;
  padding: 2rem; 
  align-items: flex-start;
  align-content: flex-start;
 }

 .header_card__dDSlV{
    display: flex;
    vertical-align: bottom;
    padding: 2rem; 
    align-items: flex-end;
    align-content: flex-end;
   }
 
   .header_card_content__eLPyT{
  background-color: var(--hsrcBackgroundLight);
  color: var(--hsrcDarkBlue);
  padding: 0.8rem;
   }

    
   .header_card_main__2dJtW{
    display: flex;
    flex-direction: column;
    align-content: center;
    align-items: center;
    margin-left:  3rem;
    margin-bottom: 1rem;
    margin-top: 1rem;
    border-radius: 15px;
    background-color: var(--hsrcBackgroundLight);
    border-color: var(--hsrcDarkYellow);
    border-style: solid;
    border-width: 0.1rem;
    color: var(--hsrcDarkBlue);
   }`, "",{"version":3,"sources":["webpack://./src/pages/RespondentDashboard/components/Header/header.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,UAAQ;IACR,mBAAmB;IACnB,uBAAuB;IACvB,yBAAyB;IACzB,uBAAuB;IACvB,4CAA4C;IAC5C,mBAAmB;IACnB,6BAA6B;;;CAGhC;;CAEA;EACC,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,uBAAuB;EACvB,yBAAyB;CAC1B;;CAEA;IACG,aAAa;IACb,sBAAsB;IACtB,aAAa;IACb,qBAAqB;IACrB,uBAAuB;GACxB;;GAEA;EACD,4CAA4C;EAC5C,0BAA0B;EAC1B,eAAe;GACd;;;GAGA;IACC,aAAa;IACb,sBAAsB;IACtB,qBAAqB;IACrB,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;IACnB,4CAA4C;IAC5C,mCAAmC;IACnC,mBAAmB;IACnB,oBAAoB;IACpB,0BAA0B;GAC3B","sourcesContent":[".header_container{ \r\n    display: flex;\r\n    flex:  5;\r\n    flex-direction: row;\r\n    align-items: flex-start;\r\n    align-content: flex-start;\r\n    justify-content: center;\r\n    background-color: var(--hsrcBackgroundLight);\r\n    border-radius: 1rem;\r\n    justify-content: space-around;\r\n    \r\n\r\n }\r\n\r\n .banner{\r\n  display: flex;\r\n  vertical-align: bottom;\r\n  padding: 2rem; \r\n  align-items: flex-start;\r\n  align-content: flex-start;\r\n }\r\n\r\n .card{\r\n    display: flex;\r\n    vertical-align: bottom;\r\n    padding: 2rem; \r\n    align-items: flex-end;\r\n    align-content: flex-end;\r\n   }\r\n \r\n   .card_content{\r\n  background-color: var(--hsrcBackgroundLight);\r\n  color: var(--hsrcDarkBlue);\r\n  padding: 0.8rem;\r\n   }\r\n\r\n    \r\n   .card_main{\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-content: center;\r\n    align-items: center;\r\n    margin-left:  3rem;\r\n    margin-bottom: 1rem;\r\n    margin-top: 1rem;\r\n    border-radius: 15px;\r\n    background-color: var(--hsrcBackgroundLight);\r\n    border-color: var(--hsrcDarkYellow);\r\n    border-style: solid;\r\n    border-width: 0.1rem;\r\n    color: var(--hsrcDarkBlue);\r\n   }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"header_container": `header_header_container__fs+2C`,
	"banner": `header_banner__lF6g8`,
	"card": `header_card__dDSlV`,
	"card_content": `header_card_content__eLPyT`,
	"card_main": `header_card_main__2dJtW`
};
export default ___CSS_LOADER_EXPORT___;
